export default __webpack_public_path__ + "cadd408a28a635167e703fddf74773ad.png";